import { action } from 'mobx';
import { container, singleton } from 'tsyringe';

import { ToastStatus, ToastStore } from '../stores/toast/toast-store';

@singleton()
export class ToastStoreFacade {
  public get originalStore() {
    return container.resolve(ToastStore);
  }

  public get list() {
    return this.originalStore.list;
  }

  @action.bound
  addToast(label: string, status: ToastStatus) {
    return this.originalStore.addToast(label, status);
  }

  @action.bound
  clearToast(id?: number, label?: string) {
    return this.originalStore.clearToast(id, label);
  }

  @action.bound
  clearAll() {
    return this.originalStore.clearAll();
  }
}
